<nz-spin [nzSimple]="true" [nzIndicator]="indicatorTemplate"  [nzSpinning]="true" nzSize="large" style="background-color: rgba(0, 0, 0, 0.1);"></nz-spin>
<ng-template #indicatorTemplate>
    <div class="container">
        <div class="item item-1"></div>
        <div class="item item-2"></div>
        <div class="item item-3"></div>
        <div class="item item-4"></div>
      </div>
</ng-template>
